import { Routes } from '@angular/router';

import { mpsAuthRoutes } from './mps-auth.routes';
import { mpsCoreRoutes } from './mps-core.routes';

export const mpsRoutes: Routes = [...mpsCoreRoutes, ...mpsAuthRoutes];
